import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {FlowBasicState} from '@gongxigames/framework/slot/modules/flow/states/FlowBasicState';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import { BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';

export class FlowFirecatcherState extends FlowBasicState {

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onAllReelsStopped(): void {
        this.clearEventsQueue();

        switch (this.module.logic.nextAction) {
            case Action.SPIN: {
                this.emit(ReelsEvents.DISABLE_SPIN_BY_SPIN_BUTTON);
                this.emit(FlowModuleEvents.NO_RESPIN_ON_NEXT_SPIN);
                break;
            }

            case Action.RESPIN: {
                this.setupRespin();
                break;
            }

            case Action.FREESPIN: {
                this.emit(FlowModuleEvents.NO_RESPIN_ON_NEXT_SPIN);
                break;
            }

            default:

                break;
        }
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.RESPIN_OUTRO) {
            this.onRespinOutroFinished();
        }
    }

    protected onRespinOutroFinished(): void {
        if (this.isBigWinInCurrentRound()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.onBigWinAfterFirecatcherFinished.bind(this));
        } else {
            this.exitFromState();
        }
    }

    protected onBigWinAfterFirecatcherFinished(): void {
        this.exitFromState();
    }

    protected isBigWinInCurrentRound(): boolean {
        return this.getFeatureWin() + this.module.logic.getBaseWinFromTriggeringRound(this.convertPreviousActionToBonusID()) >=
            this.module.logic.getBigWinLimit();
    }

    protected convertPreviousActionToBonusID(): number {
        return this.module.logic.previousAction - 1;
    }

    protected getFeatureWin(): number {
        return this.module.logic.getTotalWin() - this.module.logic.previousSpinRoundWin;
    }

    protected restoreFirecatcherWinningRoundWinPresentation(): void {
        this.emit(FlowModuleEvents.WP_RESTORE, this.module.logic.getSessionForRespinWinningRound());
    }

    protected exitFromState(): void {
        this.emit(ReelsEvents.ENABLE_SPIN_BY_SPIN_BUTTON);
        this.module.gotoState(FlowModule.BASIC_STATE);
        this.restoreFirecatcherWinningRoundWinPresentation();
    }
}
